import React, { useState }                from 'react';
import { useDispatch, useSelector }       from 'react-redux';

import Loading                            from './components/Loading';
import Parameters                         from './components/Parameters';
import Prices                             from './components/Prices'

const Assembly = () => {
  return (
    <>
      <div>
        <Loading />
        <div className="row">
          <div className="col-lg-4">
            <Parameters />
          </div>
          <div className="col-lg-8">
            <Prices />
          </div>
        </div>
      </div>
    </>
  )
}

export default Assembly;